import React from "react";
import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import { connect } from "react-redux";
import { AppleStoreButton, PlayStoreButton } from "components/PlayStoreButton";

const CenterFooterMobile = (props) => {
  const { organizationInfo } = props;
  const isShowAppStoreBand =
    organizationInfo?.organizationOptionJson?.showAppStoreBand?.toLowerCase() ===
    "y";
  return (
    <Box>
      {isShowAppStoreBand && (
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Grid
              className="home-center-footer"
              sx={{
                backgroundColor:
                  organizationInfo?.app?.appCode !== "CVD"
                    ? `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}  !important`
                    : undefined,
                backgroundImage:
                  organizationInfo?.app?.appCode !== "CVD"
                    ? `none !important`
                    : undefined,
                width: "100%",
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <AppleStoreButton storeBtnId="homeStoreBtn" />

              <PlayStoreButton storeBtnId="homeStoreBtn" />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data || {},
  };
};

export default connect(mapStateToProps)(CenterFooterMobile);